interface Props {
  eyebrow: string;
  title: string;
  desc?: string;
  light?: boolean;
}

export default function SectionHeading({ eyebrow, title, desc, light }: Props) {
  return (
    <div className="max-w-2xl">
      <p
        className={`inline-flex items-center gap-2 text-sm font-semibold tracking-wide uppercase ${
          light ? "text-gold-400" : "text-coral-600"
        }`}
      >
        <span className="inline-block w-6 h-px bg-current"></span>
        {eyebrow}
      </p>
      <h2
        className={`mt-3 font-display text-3xl md:text-4xl leading-tight ${
          light ? "text-paper-50" : "text-ink-900"
        }`}
      >
        {title}
      </h2>
      {desc && (
        <p className={`mt-3 leading-relaxed ${light ? "text-paper-50/70" : "text-ink-700/80"}`}>
          {desc}
        </p>
      )}
    </div>
  );
}